import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE_URL } from "../config";

function SignUp() {
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [abn, setAbn] = useState("");

  const [category, setCategory] = useState("");

  const [acceptedTerms, setAcceptedTerms] = useState(false);


  const [abnValid, setAbnValid] = useState(null);
  const [abnError, setAbnError] = useState("");
  const [businessName, setBusinessName] = useState("");

  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  

  // ===== ABN Validation =====
  useEffect(() => {
    const validateAbn = async () => {
      if (!abn) {
        setAbnValid(null);
        setAbnError("");
        setBusinessName("");
        return;
      }

      const cleanAbn = abn.replace(/\D/g, "");

      // Dummy ABN for testing
      if (cleanAbn === "11111111111") {
        setAbnValid(true);
        setAbnError("");
        setBusinessName("Dummy Business");
        return;
      }

      if (cleanAbn.length === 11) {
        try {
          const res = await fetch(`${API_BASE_URL}/api/verify-abn`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ abn: cleanAbn }),
          });

          const data = await res.json();
          if (res.ok && data.verified) {
            setBusinessName(data.entityName || "Verified Business");
            setAbnValid(true);
            setAbnError("");
          } else {
            setAbnValid(false);
            setAbnError(data.message || "Invalid or inactive ABN");
          }
        } catch (err) {
          console.error("ABN validation error:", err);
          setAbnValid(false);
          setAbnError("Error validating ABN");
        }
      } else if (cleanAbn.length > 0) {
        setAbnValid(false);
        setAbnError("ABN must be exactly 11 digits");
      } else {
        setAbnValid(null);
        setAbnError("");
        setBusinessName("");
      }
    };

    validateAbn();
  }, [abn]);

  // ===== Form Submission =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email !== confirmEmail) {
  alert("Emails do not match.");
  return;
}

if (password !== confirmPassword) {
  alert("Passwords do not match.");
  return;
}

    if (!category) {
  alert("Please select your business industry.");
  return;
}


    if (abn && !abnValid) {
      alert("Please enter a valid ABN before submitting.");
      return;
    }

    setIsSubmitting(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName,
          middleName,
          lastName,
          email,
          password,
          phone,
          companyName,
          abn,
          category,
          acceptedTerms,
          acceptedTermsVersion: "2026-05-20",
        }),
      });

      const data = await res.json();
      console.log("Signup response:", data);

      if (!res.ok) {
        setMessage(data.error || "An error occurred during signup.");
      } else {
        if (data.token && data.user) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          setMessage("✅ Signup successful! Redirecting to dashboard...");
          setTimeout(() => navigate("/dashboard"), 1200);
        } else {
          setMessage(
            "✅ Signup successful! Please check your email to verify your account before logging in."
          );
        }
      }
    } catch (err) {
      console.error("Signup error:", err);
      setMessage("❌ An error occurred during signup. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: "center", marginBottom: "25px" }}>Sign Up</h2>

      <p
  style={{
    textAlign: "center",
    fontSize: "14px",
    color: "#555",
    marginBottom: "20px",
  }}
>
  Create your Client Exchange account to buy, sell, and swap service clients with verified contractors.
</p>

      {message && <div style={messageStyle}>{message}</div>}

      <form onSubmit={handleSubmit} style={formStyle}>

      {/* ✅ Name Fields */}
<div style={{ display: "flex", gap: "10px", width: "100%" }}>
  <input
    type="text"
    placeholder="First Name"
    value={firstName}
    onChange={(e) => setFirstName(e.target.value)}
    style={{ ...inputStyle, flex: 1, minWidth: 0 }}
    required
  />
  <input
    type="text"
    placeholder="Last Name"
    value={lastName}
    onChange={(e) => setLastName(e.target.value)}
    style={{ ...inputStyle, flex: 1, minWidth: 0 }}
    required
  />
</div>

<input
  type="text"
  placeholder="Middle Name (if applicable)"
  value={middleName}
  onChange={(e) => setMiddleName(e.target.value)}
  style={inputStyle}
/>

        <p
  style={{
    fontSize: "12px",
    color: "#666",
    marginTop: "-8px",
    marginBottom: "5px",
    lineHeight: "1.4",
  }}
>
  Use your real name. It must match your driver's licence for identity verification.
</p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
          required
        />
        <input
  type="email"
  placeholder="Confirm Email"
  value={confirmEmail}
  onChange={(e) => setConfirmEmail(e.target.value)}
  style={inputStyle}
  required
/>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
          required
        />
        <input
  type="password"
  placeholder="Confirm Password"
  value={confirmPassword}
  onChange={(e) => setConfirmPassword(e.target.value)}
  style={inputStyle}
  required
/>
        <input
          type="text"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          style={inputStyle}
        />
        <input
          type="text"
          placeholder="Business / Trading Name (optional)"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          style={inputStyle}
        />

        <select
  value={category}
  onChange={(e) => setCategory(e.target.value)}
  style={inputStyle}
  required
>
  <option value="" disabled>
  What industry is your business in?
</option>
  <option value="lawn_mowing">Lawn Mowing</option>
  <option value="cleaning">Cleaning</option>
  <option value="pool_care">Pool Care</option>
</select>


        {/* ABN Verification */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <input
            type="text"
            placeholder="ABN"
            value={abn}
            onChange={(e) => setAbn(e.target.value)}
            style={{ ...inputStyle, flex: 1 }}
          />
          <Link
            to="/why-verify"
            style={{
              fontSize: "13px",
              color: "#2196F3",
              textDecoration: "underline",
            }}
          >
            Why verify?
          </Link>
        </div>
        {abnValid && (
          <span style={{ color: "green" }}>
            ✅ Verified Business ({businessName})
          </span>
        )}
        {abnValid === false && <span style={{ color: "red" }}>{abnError}</span>}

        <label
  style={{
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.5",
  }}
>
  <input
    type="checkbox"
    checked={acceptedTerms}
    onChange={(e) => setAcceptedTerms(e.target.checked)}
    required
    style={{ marginTop: "3px" }}
  />

  <span>
    I agree to the{" "}
    <Link
      to="/terms"
      target="_blank"
      style={{ color: "#00A859", textDecoration: "underline" }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      to="/legal"
      target="_blank"
      style={{ color: "#00A859", textDecoration: "underline" }}
    >
      Privacy Policy
    </Link>.
  </span>
</label>

        <button type="submit" style={buttonStyle} disabled={isSubmitting}>
         {isSubmitting ? "Creating Account..." : "Create Account"}
        </button>
      </form>
    </div>
  );
}

// ===== Styles =====
const containerStyle = {
  maxWidth: "500px",
  margin: "50px auto",
  padding: "30px",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  backgroundColor: "#ffffff",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "15px" };

const inputStyle = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "14px",
};

const buttonStyle = {
  padding: "15px",
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "16px",
};

const messageStyle = {
  padding: "15px",
  backgroundColor: "#f0f0f0",
  borderRadius: "8px",
  textAlign: "center",
  marginBottom: "20px",
};

export default SignUp;
